<script>
  // @ts-check
  import DynamicHeading from "../../atoms/DynamicHeading.svelte";
  import DynamicHeadingContext from "../../atoms/DynamicHeadingContext.svelte";
  import StaticMenuLink from "./StaticMenuLink.svelte";

  /** Primarily used for testing @type {string} */
  export let id = undefined;

  /** Title for accessibility @type {string} */
  export let title = undefined;

  /** @typedef {Object} Link
   * @property {string} url
   * @property {string} label
   * @property {string  | null} imageSrc
   */
  /** @type {Link[]} */
  export let links;
</script>

<DynamicHeadingContext>
  <nav {id} aria-labelledby={title}>
    <DynamicHeading class="sr-only" id={title}>{title}</DynamicHeading>
    <ul class="flex flex-col">
      {#each links as link (link.label)}
        <li class="group/li contents">
          <StaticMenuLink {link} />
        </li>
      {/each}
    </ul>
  </nav>
</DynamicHeadingContext>
